import React, { useEffect, useRef, useState } from "react";

import { WINNER_SSP, useAuctionOutcome } from "../../utils/adAuction";
import { insertDisplayCode } from "../../utils/displayCode";
import { FloatingFrame } from "./FloatingFrame";

/**
 * smi-блок floorad в аукционе: рисует displayCode ставки нашего RTB по этому блоку,
 * если она выиграла аукцион у «Моё видео».
 *
 * Контейнер без своих размеров. Для слота floorad (`floating`) он закреплён внизу
 * экрана, чтобы блок был в области видимости, а не вставал в поток после ленты.
 * Кнопка закрытия включается пропом `closable` (AdSlot передаёт её для floorad); виджет
 * smi.js закрывается сам (delay/duration/auto_close заданы в SSP). Одиночного
 * режима нет — запись без `auction` сервер не отдаёт, а если она пришла, ничего не
 * рисуется.
 */
export function SspAdapter({ entry, floating = false, closable = false }) {
    const outcome = useAuctionOutcome(entry.auction);
    const container = useRef(null);
    const inserted = useRef(false);
    const [closed, setClosed] = useState(false);
    const bid = outcome && outcome.winner === WINNER_SSP ? outcome.bid : null;

    useEffect(() => {
        if (!bid || !container.current || inserted.current) {
            return;
        }

        inserted.current = true;
        insertDisplayCode(container.current, bid.displayCode);
    }, [bid]);

    if (!entry.auction || !bid || closed) {
        return null;
    }

    if (!floating) {
        return <div ref={container} />;
    }

    return (
        <FloatingFrame closable={closable} onClose={() => setClosed(true)}>
            <div ref={container} />
        </FloatingFrame>
    );
}

export default SspAdapter;
